import styled, { keyframes } from 'styled-components';

export const TableWrapper = styled.div`
    background-color: #ffffff;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
    overflow: hidden;
`;

export const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    
    th, td {
        padding: 1rem 1.5rem;
        text-align: left;
        border-bottom: 1px solid #e9ecef;
    }

    th {
        background-color: #f8f9fa;
        color: #6c757d;
        font-size: 0.8rem;
        font-weight: 600;
        text-transform: uppercase;
    }

    td {
        color: #495057;
        font-weight: 500;
    }

    tbody tr {
        cursor: pointer;
        transition: background-color 0.2s ease;
        &:hover {
            background-color: #f1f3f5;
        }
        &:last-child td {
            border-bottom: none;
        }
    }
`;

export const Pagination = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 2rem;
    gap: 0.5rem;

    button {
        padding: 0.5rem 1rem;
        border: 1px solid #dee2e6;
        background-color: #ffffff;
        border-radius: 6px;
        cursor: pointer;
        &:hover:not(:disabled) { background-color: #f1f3f5; }
        &:disabled { opacity: 0.6; cursor: not-allowed; }
    }

    span { color: #6c757d; font-weight: 500; }
`;

const fadeIn = keyframes`from { opacity: 0; } to { opacity: 1; }`;
const scaleIn = keyframes`from { transform: scale(0.95); } to { transform: scale(1); }`;

export const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(5px);
    z-index: 3000;
    display: flex;
    justify-content: center;
    align-items: center;
    animation: ${fadeIn} 0.3s;
`;

export const ModalContent = styled.div`
    background: #ffffff;
    border-radius: 16px;
    width: 90%;
    max-width: 500px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
    animation: ${scaleIn} 0.3s;
`;

export const ModalHeader = styled.div`
    padding: 1.5rem;
    border-bottom: 1px solid #e9ecef;
    display: flex;
    justify-content: space-between;
    align-items: center;

    h2 {
        margin: 0;
        font-size: 1.5rem;
        color: #212529;
    }
`;

export const CloseButton = styled.button`
    background: none;
    border: none;
    font-size: 1.8rem;
    color: #adb5bd;
    cursor: pointer;
    &:hover { color: #212529; }
`;

export const ModalBody = styled.div`
    padding: 2rem;
    display: grid;
    gap: 1.5rem;
`;

export const ModalInfo = styled.div`
    background-color: ${props => props.highlight ? '#e7f5ff' : '#f8f9fa'};
    padding: 1rem;
    border-radius: 8px;
    border: 1px solid ${props => props.highlight ? '#bde0fe' : '#e9ecef'};
    
    span {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        font-size: 0.875rem;
        font-weight: 500;
        color: #6c757d;
        margin-bottom: 0.5rem;
    }
    
    p {
        margin: 0;
        font-size: 1.5rem;
        font-weight: 600;
        color: ${props => props.highlight ? '#007bff' : '#212529'};
    }
`;